import { useSelector } from 'react-redux';

export const useFacilityId = () => {
    const facility_id = useSelector(state => state.Facility.selected.Id) ?? '';
    return facility_id;
}